import VideoIcon from '@/components/assets/icon_trailer_video.svg'
import { MEDIA_TYPE } from '@/hooks/useTrailerViewMedia'
import thumbnailDefaultIcon from '@/public/images/thumbnail_default.png'
import Image from 'next/image'
import { RefObject } from 'react'

interface MediaItem {
  url: string
  type: string
  isConverted?: boolean
  coverImage?: string
}

interface TrailerThumbnailItemProps {
  item: MediaItem
  index: number
  currentIndex: number
  thumbWidth: number
  handleClick: (index: number) => void
  thumbnailRef: RefObject<(HTMLDivElement | null)[]>
  updateScrollFade: () => void
  imgErrorArr: boolean[]
  handleImgError: (idx: number) => void
}

const TrailerThumbnailItem = ({
  item,
  index,
  currentIndex,
  thumbWidth,
  handleClick,
  thumbnailRef,
  updateScrollFade,
  imgErrorArr,
  handleImgError,
}: TrailerThumbnailItemProps) => {
  const isActive = currentIndex === index
  const isVideo = item.type === MEDIA_TYPE.VIDEO
  const isConverted = item.isConverted
  const commonProps = {
    onClick: () => handleClick(index),
    className: `w-full transition-all h-full object-cover rounded-lg cursor-pointer ${isActive ? 'border-4 border-vive-brand-50' : ''}`,
    onLoad: updateScrollFade,
  }
  return (
    <div
      className="relative aspect-[16/9] flex-shrink-0 overflow-hidden rounded-lg"
      style={{ width: thumbWidth }}
      key={`${item.url}-${index}`}
      ref={(el) => {
        thumbnailRef.current[index] = el
      }}
    >
      {isVideo ? (
        isConverted ? (
          <Image
            src={
              imgErrorArr[index] ? thumbnailDefaultIcon : item.coverImage || thumbnailDefaultIcon
            }
            alt=""
            fill
            className={commonProps.className}
            onError={() => handleImgError(index)}
            onClick={commonProps.onClick}
            onLoad={commonProps.onLoad}
          />
        ) : (
          <video src={item.url} muted autoPlay playsInline controls={false} {...commonProps} />
        )
      ) : (
        <Image
          src={imgErrorArr[index] ? thumbnailDefaultIcon : item.url}
          alt=""
          fill
          className={commonProps.className}
          onError={() => handleImgError(index)}
          onClick={commonProps.onClick}
          onLoad={commonProps.onLoad}
        />
      )}
      {isVideo && (
        <VideoIcon className="pointer-events-none absolute bottom-[5px] left-[6px] h-[14px] w-[14px] 2xl:h-[16px] 2xl:w-[16px]" />
      )}
    </div>
  )
}
export default TrailerThumbnailItem
